// Widerrufsbutton (Sitzung „Aufräumen“, 14.10.2026): was die Seite `/vertrag-widerrufen` braucht, ohne Importe (der Test
// der Function liest diese Datei auch unter Deno). Die Function `vertrag-erklaerung` prüft dieselben Angaben noch
// einmal selbst (`logik.ts`); die Liste der Verträge steht dort ein zweites Mal, ein Test hält beide gleich.
//
// Einen Kündigungsbutton gibt es hier nicht (Daniel, 15.10.2026): Gekündigt wird im Konto unter „Mein Account“ →
// „Abo & Rechnungen“ → „Abo kündigen“, das läuft ohne Handarbeit.

export const VERTRAEGE = [
  "Mitgliedschaft",
  "MusiKonzept Kompakt",
  "Taler-Paket (Musiktaler)",
  "Ausbildung Fachkraft für Musik im Elementarbereich",
  "Ausbildung Fachkraft für Musik und Sprache im Elementarbereich",
  "Der große Kita-Gitarrenkurs",
  "Musik-Kita-Paket",
  "Webinar oder Termin",
  "Themenreise",
  "Einzelner Kurs",
  "Anderer Vertrag",
] as const;

/** Wo man kündigt (Konto, Reiter „Abo & Rechnungen“ in `StudentSettings`) */
export const KONTO_PFAD = "/mein-bereich/einstellungen";

export const WIDERRUF_PFADE = { formular: "/vertrag-widerrufen", bestaetigung: "/vertrag-widerrufen/bestaetigung" };

export interface ErklaerungEingabe {
  art: "widerruf";
  name: string;
  email: string;
  vertrag: string;
  vertrag_details?: string;
  kundennummer?: string;
  vertragsdatum?: string;
  /** Verstecktes Feld, das nur Programme ausfüllen */
  website?: string;
}

/** Was die Bestätigungsseite zeigt (kommt über den Verlauf mit, nicht über die Adresse). */
export interface ErklaerungBestaetigung {
  eingabe: ErklaerungEingabe;
  eingegangen_am: string;
  referenz: string;
  mail_gesendet: boolean;
}

/** „14.10.2026, 21:15:30 Uhr“ in deutscher Zeit */
export function zeitpunktText(iso: string): string {
  const d = new Date(iso);
  const tag = d.toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Berlin" });
  const uhr = d.toLocaleTimeString("de-DE", { hour: "2-digit", minute: "2-digit", second: "2-digit", timeZone: "Europe/Berlin" });
  return `${tag}, ${uhr} Uhr`;
}

/** „2026-12-31“ → „31.12.2026“ */
export function tagText(iso: string): string {
  const [j, m, t] = iso.split("-");
  return `${t}.${m}.${j}`;
}

/** Die Angaben als Zeilen für die Bestätigungsseite (dieselben wie in der Mail). */
export function angabenZeilen(e: ErklaerungEingabe): [string, string][] {
  const zeilen: [string, string][] = [
    ["Art", "Widerruf"],
    ["Name", e.name.trim()],
    ["E-Mail-Adresse", e.email.trim().toLowerCase()],
    ["Vertrag", e.vertrag],
  ];
  if (e.vertrag_details?.trim()) zeilen.push(["Angaben zum Vertrag", e.vertrag_details.trim()]);
  if (e.kundennummer?.trim()) zeilen.push(["Kunden- oder Rechnungsnummer", e.kundennummer.trim()]);
  if (e.vertragsdatum) zeilen.push(["Bestellt am", tagText(e.vertragsdatum)]);
  return zeilen;
}
